import {
  selectOrganizationId,
  useInfiniteScroll,
  useLazyGetEventsQuery,
} from '@carboncopyco/data';
import type {
  Activity,
  IDemo,
  IPresentation,
  IRecording,
} from '@carboncopyco/types';
import { Container, PageHeader, SkeletonRowLoading } from '@carboncopyco/ui';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { usePageEvent } from '../../hooks/usePageEvents';
import { InfiniteList } from '../InfiniteList';
import { useTeamActivityProps } from './TeamActivityContext';
import { TeamActivityList } from './TeamActivityList';

export const TeamActivity = () => {
  const organizationId = useSelector(selectOrganizationId);
  const {
    items: activities,
    isLoading,
    isLoadingBatch,
    error,
    fetchFirstBatch,
    fetchNextBatch,
  } = useInfiniteScroll<Activity<IDemo | IRecording | IPresentation>>(
    useLazyGetEventsQuery
  );
  usePageEvent();

  const {
    goToDemoPageByWorkspace,
    goToClonePageByWorkspace,
    goToPresentationPageFromHomepage,
  } = useTeamActivityProps();

  useEffect(() => {
    fetchFirstBatch({ organizationId });
  }, []);

  return (
    <div className="flex flex-col h-full w-full overflow-y-hidden">
      <PageHeader title="All activity" />
      <div className="flex-auto w-full overflow-y-hidden">
        <InfiniteList
          error={
            error && {
              message: 'Error fetching team activity',
            }
          }
          isLoading={isLoading}
          isLoadingBatch={isLoadingBatch}
          loader={
            <Container>
              <SkeletonRowLoading itemsCount={10} />
            </Container>
          }
          onReachBottom={() => fetchNextBatch({ organizationId })}
        >
          <Container>
            <TeamActivityList
              activities={activities}
              goToDemoPageByWorkspace={goToDemoPageByWorkspace}
              goToClonePageByWorkspace={goToClonePageByWorkspace}
              goToPresentationPageFromHomepage={
                goToPresentationPageFromHomepage
              }
            />
          </Container>
        </InfiniteList>
      </div>
    </div>
  );
};
